import { useMediaQuery } from '@react-hook/media-query';

const createMinMediaQuery = (screen) =>
  `only screen and (min-width: ${screen}px)`;

const useCustomMediaQuery = (screenSize) =>
  useMediaQuery(createMinMediaQuery(screenSize));

export default useCustomMediaQuery;
